import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import { zoomInDown } from 'react-animations';
import { lightSpeedIn } from 'react-animations';
import Radium, {StyleRoot} from 'radium';
import  Sidebar from "./Sidebar";
import Fade from 'react-reveal/Fade';


const styles = {
  zoomInDown: {
    animation: 'x 5s',
    animationName: Radium.keyframes(zoomInDown, 'zoomInDown')
  }
}

const stylesLigh = {
  lightSpeedIn: {
    animation: 'x 5s',
    animationName: Radium.keyframes(lightSpeedIn, 'lightSpeedIn')
  }
}



class NosValeurs extends Component {
 constructor(props) {
    super(props);
    this.state = { show: false, show1:false, show2:false, show3:false };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(b) {
    if (b===1){
      this.setState({ show: !this.state.show });
    }
      if (b===2){
      this.setState({ show1: !this.state.show1 });
    }
      if (b===3){
      this.setState({ show2: !this.state.show2 });
    }
      if (b===4){
      this.setState({ show3: !this.state.show3 });
    }

   
  }



  render() {
    return (
    <div>   
    <section className="inner-intro bg-image overlay-dark parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg5.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Green Agro Business</a>/<span>Nos engagements</span>
                    </div>
                </div>
            </div>
        </section>
   <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
          

            <div className="row inside_content">

           <div className="col-md-12">
      <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/> Nos Engagements</h3>

     <div className="row">
     
      <div className="col-md-4">

      <StyleRoot>
      <div className="accordion">
        <div className="card pricing style2 boxShadow" style={styles.zoomInDown}>
            <div className="card-block">
             <img src="/assets/img/feuille.png" className="leaf rse_leaf"/>
             <h4 className="text-center title_value">SATISFACTION CLIENTS</h4>
             <hr/>
                    <p className="paragrah">Nous priorisons la satisfaction client tout en développant une exigence d’excellence en terme de produits et de process.  Nous faisons également preuve d’une grande adaptabilité et réactivité vis-à-vis des contraintes de nos clients...</p>
                
                  <Fade bottom collapse when={this.state.show}>
                      <p className="test"> Nos techniciens agronomes accompagnent quotidiennement les agriculteurs sur le terrain. Au-delà du conseil technique c’est une approche et analyse globale qui sont proposées. Face aux enjeux climatiques, et questions alimentaires, Green Agro business s’est engagé à modifier les pratiques agricoles des agriculteurs pour nourrir durablement la planète.</p>
                     </Fade>
                  <button
                      className="btn btn-md btn-black-line boutonvaleur"
                      type="button"
                      onClick={()=>this.handleClick(1)}>
                      { this.state.show ? 'Fermer' : 'Lire la suite' }
                  </button>

     
                     
              

            </div>
          </div>
          </div>
          </StyleRoot>
    </div>


    <div className="col-md-4">
    <StyleRoot>
          <div className="card pricing style2 boxShadow" style={styles.zoomInDown}>
            <div className="card-block">
             <img src="/assets/img/feuille.png" className="leaf rse_leaf"/>
           <h4 className="text-center title_value">QUALITE</h4>
           <hr/>
           <p className="paragrah">Nous nous engageons tout au long de nos process à veiller à la qualité de nos produits et services. Nous tissons de solides partenariats avec l’ISRA (Institut Sénégalais de Recherches Agricoles) et structures homologuées pour veiller à la qualité et...</p>
            <Fade bottom collapse when={this.state.show1}>
            <p className="test"> engageons une démarche de Certification BIO Green Agro Business assure une qualité agronomique optimale bénéficiant d’un outil de production industriel performant. La performance de nos solutions est reconnue par des homologations biologiques. Pour l’agriculteur c’est un gage de qualité et la reconnaissance de la gamme des produits biologiques Green Agro Business.</p>
            </Fade>
                  <button
                      className="btn btn-md btn-black-line boutonvaleur"
                      type="button"
                      onClick={()=>this.handleClick(2)}>
                      { this.state.show1 ? 'Fermer' : 'Lire la suite' }
                  </button>
          
            </div>

            </div>
          
          </StyleRoot>
    </div>
    <div className="col-md-4">
    <StyleRoot>
          <div className="card pricing style2 boxShadow rpect" style={styles.zoomInDown}>
            <div className="card-block">
             <img src="/assets/img/feuille.png" className="leaf rse_leaf"/>
           <h4 className="text-center respect_envi">RESPECT DE L’ENVIRONNEMENT</h4>
           <hr/>
           <p className="paragrah">L’humain étant au cœur de la stratégie de Green Agro Business, nous mettons un point d’honneur au respect des bonnes pratiques au sein de tous les départements de l’entreprise pour apporter des solutions écologiques et durable pour notre planète...</p>
           <Fade bottom collapse when={this.state.show2}>
                <p className="test">Green Agro business et le ministère en charge de l’environnement contribuent à la sécurité alimentaire par la lutte contre la dégradation des sols, nous restons résolument engagés dans l’atténuation des risques liés aux changements climatiques dans le développement durable.</p>
            </Fade>
                  <button
                      className="btn btn-md btn-black-line boutonvaleur"
                      type="button"
                      onClick={()=>this.handleClick(3)}>
                      { this.state.show2 ? 'Fermer' : 'Lire la suite' }
                  </button>
         


            </div>
          </div>
          </StyleRoot>
    </div>

    </div>
 
    


</div>


</div>

</div>

</section>
      <hr />

    </div>
       
        

    )
  }
}
export default NosValeurs;


// WEBPACK FOOTER //
// ./src/components/valeur.jsx